/**
 * Resolve a media URL for use with NuxtImg.
 * - Local paths (/) → use as-is with Cloudflare provider
 * - Full URLs (http) → pass through directly
 * - Relative paths → prepend Strapi base URL
 */
export function resolveMediaUrl(url: string, getStrapiMediaUrl: (url: string) => string) {
    if (url.startsWith('/')) return url
    if (url.startsWith('http')) return url
    return getStrapiMediaUrl(url)
}

export function isLocalMedia(url: string): boolean {
    return url.startsWith('/')
}
